export const PASSWORD_RECOVER_SET = 'PASSWORD_RECOVER_SET'
export const PASSWORD_RECOVER_LOAD = 'PASSWORD_RECOVER_LOAD'
export const PASSWORD_RECOVER_SUCCESS = 'PASSWORD_RECOVER_SUCCESS'
export const PASSWORD_RECOVER_FAILED = 'PASSWORD_RECOVER_FAILED'
export const PASSWORD_RECOVER_CLEAR = 'PASSWORD_RECOVER_CLEAR'
